//=====================================================
//　コンテンツタイトル
//=====================================================

interface IFProps {
　title: string
}    

export function ContentsTitle(props: IFProps){
    return (
        <h2 className="contents-title">{props.title}</h2>
    )
}